export const MAX_CLIENT_ID_LENGTH = 128;
export const MAX_DATA_SIZE = 256;
export const MAX_MEMO_CHARACTERS = 256;
